// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"authorized_wrapper__T7Fnf","wrapperWithOutSidebar":"authorized_wrapperWithOutSidebar__o9kNr","body":"authorized_body__16IEp"};